import * as Yup from 'yup';
const validationSchema = Yup.object().shape({
	name: Yup.string().required().label('League name'),

});
const Inputs = [
	{
		name: 'name',
		label: 'Name',
		type: 'text',
		value: 'single',
		valueAttr: 'name',
	},
	{
		name: "country",
		label: 'Country',
		value: "single",
		type: "select",
		valueAttr: "countryId",
		required: true,
	},
	{
		name: 'isTopLeague',
		label: 'IsTopLeague',
		type: 'checkbox',
		value: 'single',
		valueAttr: 'isTopLeague',
		required: false,
	},
	{
		name: 'topLeagueOrder',
		label: 'TopLeagueOrder',
		type: 'text',
		value: 'single',
		valueAttr: 'topLeagueOrder',
		required: false,
	},
	{
		name: 'countryIds',
		label: 'Countries',
		type: 'select',
		value: 'multiple',
		valueAttr: 'countryIds',
	},
	{
		name: 'translations',
		label: 'Translations',
		type: 'nestedArray',
		value: 'multiple',
		valueAttr: 'translations',
		columns: [
			{
				name: 'languageCode',
				label: 'Language',
				type: 'text',
				required: true,
			},
			{
				name: 'translatedName',
				label: 'Translated Name',
				type: 'text',
				required: true,
			}
		]
	}

];

export { Inputs, validationSchema };
